import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';

import {MapUtils} from '../../shared/utils/mapper';
import {FXResponse} from 'src/app/models/response.model';
import {standardizeParam} from 'src/app/shared/utils/helper';
import {APP_CONFIG} from 'src/app/shared/common/config';
import {CreditCardModel, KYCModel} from '../../models/cms.model';
@Injectable()
export class KycService {

  constructor(private http: HttpClient) {}

  getImage(params): Observable<Blob> {
    const token = localStorage.getItem('access_token');
    return this.http.get(`${APP_CONFIG.BASE_API_LINK.CMS}/base64-image?${standardizeParam(params)}&token=${token}`, {responseType: 'blob'})
      .pipe(
        map((res: any) => {
          return new Blob([res], {type: 'image/png'});
        })
      );
  }

  getKYC(params): Observable<FXResponse<KYCModel[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.CMS}/kycs?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<KYCModel[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.kyc_informations.map((kyc: any) =>
          MapUtils.deserialize(KYCModel, kyc)
        );
        return response;
      })
    );
  }
  updateKYCStatus(data: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.CMS}/kycs/process`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getCreditCard(params): Observable<FXResponse<CreditCardModel[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.CMS}/credit-cards?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<CreditCardModel[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.credit_cards.map((kyc: any) =>
          MapUtils.deserialize(CreditCardModel, kyc)
        );
        return response;
      })
    );
  }

  updateCreditCardStatus(data: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.CMS}/credit-cards/process`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  updateKycComment(data: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.CMS}/kycs/comment`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
